<template>
	<div class="role">
		<div class="right-wrap">
			<div class="query-wrap">
				<div class="qjc-flex">
					<el-select v-model="packageVal" class="query-package" @change="handleChangeSelect">
						<el-option v-for="item in packageList" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
					<div class="query-date">
						<div class="query-date-label">操作日期</div>
						<el-date-picker v-model="searchDate" type="daterange" value-format="timestamp"
							range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期"
							@change="searchDateChange">
						</el-date-picker>
					</div>
				</div>


				<el-button @click="handleQuery" class="add qjc-fts-16">查 询</el-button>
				<el-button @click="handleRet" class="add qjc-fts-16">重 置</el-button>
			</div>

			<div class="table-list">
				<el-table :data="lists" class="list" style="width: 100%">
					<template slot="empty">
						<div class="empty-wrap">
							<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
							<div class="empty-text">暂无数据</div>
						</div>
					</template>
					<el-table-column prop="id" label="编号" class-name="id" min-width='60'></el-table-column>
					<el-table-column prop="mobile" label="手机号" class-name="mobile" min-width='120'>
						<template slot-scope="scope">
							{{ scope.row.mobile?scope.row.mobile:'--' }}
						</template>
					</el-table-column>
					<el-table-column prop="order_no" label="订单编号" class-name="order_no" min-width='200'></el-table-column>
					<el-table-column prop="goods_name" label="套餐内容" class-name="package" min-width="140">
						<template slot-scope="scope">
							<span class="package-name">{{ scope.row.goods_name }}</span>
							<span class="custom_info" v-if="scope.row.package == 2">
								<el-tooltip :content="customFun(scope.row.custom)" placement="bottom">
									<i class="el-icon-info"></i>
								</el-tooltip>
							</span>
						</template>
					</el-table-column>
					<el-table-column prop="amount" label="订单金额(元)" class-name="amount" min-width="120">
						<template slot-scope="scope">
							{{ scope.row.amount?scope.row.amount:'--' }}
						</template>
					</el-table-column>
					<el-table-column prop="coupon" label="优惠" class-name="coupon" min-width='180'>
						<template slot-scope="scope">
							<div class="" v-if="scope.row.coupon">
								<span
									class="">类别：{{scope.row.coupon.type == 1 ? '固定金额' : scope.row.coupon.type == 2 ? '优惠金额' : scope.row.coupon.type == 3 ? '优惠折扣' : ''}}</span><br>
								<span class="">优惠码：{{scope.row.coupon.code}}</span><br>
								<span
									class="">{{scope.row.coupon.type == 3 ? '折扣' : '金额'}}：{{scope.row.coupon.amount}}{{scope.row.coupon.type == 3 ? '%' : '元'}}</span>
							</div>
							<div class="" v-else>--</div>
						</template>
					</el-table-column>
					<el-table-column prop="pay_cash_fee" label="实付金额(元)" class-name="pay_cash_fee" min-width="120">
						<template slot-scope="scope">
							{{ scope.row.pay_cash_fee ? scope.row.pay_cash_fee: '--'}}
						</template>
					</el-table-column>
					<el-table-column prop="pay_status" label="支付状态" class-name="pay_status" min-width="120">
						<template slot-scope="scope">
							<span class="order_status_80" v-if="scope.row.pay_status == 1 ">已支付</span>
							<span class="pay_status_1" v-if="scope.row.pay_status == 0 ">未支付</span>
						</template>
					</el-table-column>
					<el-table-column prop="pay_at" label="付款日期" width="170px" class-name="pay_at time-string">
						<template slot-scope="scope">
							<span>{{scope.row.pay_at != 0 ? scope.row.pay_at : '--'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="order_status" label="订单状态" class-name="order_status">
						<template slot-scope="scope">
							<!-- <span>{{scope.row.order_status == 80 ? '已完成' : scope.row.order_status == 1 ? '未完成' : '--'}}</span> -->
							<span class="order_status_80" v-if="scope.row.order_status == 80 ">已完成</span>
							<span class="order_status_1" v-if="scope.row.order_status == 1 ">未完成</span>
							<span class="order_status_0" v-if="scope.row.order_status == 0 ">--</span>
						</template>
					</el-table-column>
					<el-table-column prop="device" label="下单设备" class-name="device"></el-table-column>
					<el-table-column prop="channel" label="下单渠道" class-name="channel" width="110">
					</el-table-column>
					<el-table-column label="支付方式" prop="pay_type" class-name="pay_type"></el-table-column>
					<el-table-column prop="created_at" label="操作日期" width="200px" class-name="created_at time-string">
					</el-table-column>

				</el-table>

			</div>


			<el-pagination prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" hide-on-single-page
				:current-page.sync="pager.page" :page-count="pager.pagecount" :page-size="pager.pagesize"
				:total="pager.count" @current-change="pageChange">
			</el-pagination>
		</div>


	</div>
</template>

<script>
	import {
		getOrder,
		getGoodsList
	} from "@/utils/axios"

	export default {
		name: 'mainOrder',
		data() {
			return {
				submiting: false, //正在请求
				lists: [],
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) -
					60,
				companyList: [],
				pager: {
					count: 0,
					page: 1, // 默认第一页
					pagecount: 0,
					pagesize: 12 //默认一页15条数据
				},
				enpId: '',
				packageList: [],
				packageVal: '',
				searchDate: '', //检索日期
				selectRowData: [], // 存储所选列表行数据
			}
		},
		mounted() {
			this.getHistoryList();
			this.handleGoodsList();
		},
		methods: {
			customFun(data) {
				let name = '';
				data.map((item) => {
					if (item == 'base') {
						name = name + '基础体检套餐，'
					}
					if (item == 'mlev') {
						name = name + '增值包-通用健康评分，'
					}
					if (item == 'packageA') {
						name = name + '增值包-同族群PLM对比，'
					}
					if (item == 'packageB') {
						name = name + '增值包-共病风险，'
					}
					if (item == 'packageC') {
						name = name + '增值包-疾病风险远期预测，'
					}
					if (item == 'packageD') {
						name = name + '增值包-健康促进方案，'
					}
					if (item == 'packageFB') {
						name = name + '增值包-骨折风险评估，'
					}
				})

				return name.substring(0, name.length - 1)
			},
			handleEnp(id) {
				this.packageVal = ''
				this.searchDate = ''
				this.pager.page = 1
				this.getHistoryList()
			},
			// 查询
			searchDateChange(daterange) {
				// this.pager.page = 1
				// this.getHistoryList();
			},
			handleChangeSelect(val) {
				// this.pager.page = 1
				// this.getHistoryList();
			},
			handleQuery() {
				this.pager.page = 1
				this.getHistoryList();
			},
			handleRet() {
				this.packageVal = ''
				this.searchDate = ''
				this.pager.page = 1
				this.getHistoryList();
			},
			pageChange(page) {
				this.pager.page = page;
				this.getHistoryList();
			},
			handleGoodsList() {
				getGoodsList().then((res) => {
					if (res.code == 200) {
						let goodsList = JSON.parse(window.atob(res.data))
						let list = []
						goodsList.map((goods) => {
							list.push({
								id: goods.id,
								name: goods.name
							})
						})
						list.unshift({
							id: '',
							name: '全部套餐'
						})
						this.packageList = list
					}
				})
			},
			// 获取列表
			getHistoryList() {
				// page 分页  act 操作类型
				let data = {}
				data = {
					startat: this.searchDate && this.searchDate.length > 0 ? this.searchDate[0] / 1000 : '',
					endat: this.searchDate && this.searchDate.length > 0 ? this.searchDate[1] / 1000 + 86399 : '',
					goods_id: this.packageVal,
					page: this.pager.page,
					pagesize: this.pager.pagesize
				}
				getOrder(data).then(res => {
					if (res.code == 200) {
						// 历史记录列表数据
						// this.lists = res.data.data;
						let result = JSON.parse(window.atob(res.data))
						let list = result.data;
						this.lists = list

						// 分页
						var pager = result.pager;
						for (var key in pager) {
							pager[key] = parseInt(pager[key]);
						}
						this.pager = pager;
					} else {
						this.$myAlert({
							type: 'fail',
							content: res.msg
						});
					}
				});
			},
		}
	}
</script>

<style scoped>
	.right-wrap>>>.el-table th {
		background-color: #F2F4FA;
	}

	.right-wrap>>>.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 380px;
	}

	.right-wrap>>>.el-date-editor .el-range-separator {
		color: #DBDDE6;
	}

	.time-string>>>.cell {
		white-space: nowrap;
	}

	.package>>>.cell {
		white-space: nowrap !important;
	}
</style>
<style lang="scss" scoped>
	.package-name {
		white-space: nowrap;
	}

	.table-list {
		width: 100%;
		// width: 1640px;
		overflow-x: hidden;
	}


	.role {
		display: flex;
		// padding: 24px;
		width: 100%;
		min-width: 1200px;
		height: 100%;
		padding-top: 0;

		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 0 24px 30px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;

			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;

				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;

					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}

				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}

			.left-list {
				padding-top: 20px;
			}

			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				&:hover {
					color: #7A92FB;
				}
			}

			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}

			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF5219;
				background-color: #FDE8E2;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}

			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #DCE3FF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}

		.right-wrap {
			position: relative;
			width: 100%;
			height: 100%;
			flex: 1;
			padding: 28px 24px;
			padding-top: 0;

			.query-wrap {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				// justify-content: space-between;
				margin-bottom: 16px;

				.query-package {
					width: 226px;
				}
			}

			.c-danger {
				color: #FF4C52;
			}

			.query-date {
				display: flex;
				align-items: center;
				margin-right: 40px;
				margin-left: 32px;

				.query-date-label {
					margin-right: 10px;
				}
			}

			.query-btn {
				width: 96px;
				height: 34px;
				background: #6883FB;
				font-size: 14px;

				color: #FFFFFF;
				border: none;
			}

			.el-button:active {
				background-color: #5B73DC;
			}
		}

		.foot-pagination {
			// position: absolute;
			// bottom: 0;
			width: 96%;
			padding-bottom: 20px;
			// height: 80px;
		}

		.pagination {
			width: 100%;
			margin-top: 24px;
			text-align: center;
		}

		.empty-wrap {
			padding: 100px 0;
		}

		.empty-img {
			width: 338px;
			height: 218px;
		}

	}

	.order_status_80 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #5eb95e;
	}

	.pay_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #dd514c;
	}

	.order_status_1 {
		display: inline-block;
		padding: 2px 8px;
		border-radius: 4px;
		color: #fff;
		background-color: #F37B1D;
	}

	.add {
		padding: 8px 18px;
		margin: 24px 0 12px;
		color: #fff;
		margin-right: 12px;
	}



	.time-string {
		white-space: nowrap;
	}
</style>